module.exports = __webpack_public_path__ + "static/media/pistol-poem1.5087eb58.jpg";